import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback, useEffect } from 'react';
import { loadPostStatsAtom, type PostStats, postStatsAtomFamily } from '../stats';

export interface UsePostStatsProps {
    postId: string;
}

export interface UsePostStatsReturn {
    postStats: PostStats | undefined;
    loadPostStats: () => Promise<PostStats>;
    isLoading: boolean;
}

export function usePostStats(props: UsePostStatsProps): UsePostStatsReturn {
    const { postId } = props;

    const postStats = useAtomValue(postStatsAtomFamily(postId));
    const loadStats = useSetAtom(loadPostStatsAtom);

    const loadPostStats = useCallback(async () => {
        return await loadStats(postId);
    }, [loadStats, postId]);

    return {
        postStats,
        loadPostStats,
        isLoading: !postStats,
    };
}
